import type { Socket } from '~/@types/socketio.types'
import { acceptHMRUpdate, defineStore } from 'pinia'

export const useSocketStore = defineStore('socket', () => {
  const socket = ref<Socket>()

  function setSocket(s: Socket) {
    socket.value = s
  }

  return {
    setSocket,
    socket,
  }
})

if (import.meta.hot)
  import.meta.hot.accept(acceptHMRUpdate(useSocketStore, import.meta.hot))
